<script setup>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useStore } from 'dashboard/composables/store';
import { useMapGetter } from 'dashboard/composables/store';
import PageLayout from 'dashboard/components-next/captain/PageLayout.vue';
import SettingsHeader from 'dashboard/components-next/captain/pageComponents/settings/SettingsHeader.vue';
import AssistantCompanyForm from 'dashboard/components-next/captain/pageComponents/assistant/settings/AssistantCompanyForm.vue';

const { t } = useI18n();
const route = useRoute();
const store = useStore();

const uiFlags = useMapGetter('captainAssistants/getUIFlags');
const isFetching = computed(() => uiFlags.value.fetchingItem);
const isUpdating = computed(() => uiFlags.value.updatingItem);
const assistantId = computed(() => Number(route.params.assistantId));
const assistant = computed(() =>
  store.getters['captainAssistants/getRecord'](assistantId.value)
);

const companyFormRef = ref(null);

const handleHeaderClick = () => {
  if (isUpdating.value) return;
  companyFormRef.value?.submit();
};

const handleSubmit = async updatedAssistant => {
  if (isUpdating.value) return;
  try {
    await store.dispatch('captainAssistants/update', {
      id: assistantId.value,
      ...updatedAssistant,
    });
    useAlert(t('CAPTAIN.ASSISTANTS.EDIT.SUCCESS_MESSAGE'));
  } catch (error) {
    const errorMessage =
      error?.message || t('CAPTAIN.ASSISTANTS.EDIT.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};
</script>

<template>
  <PageLayout
    :is-fetching="isFetching"
    :show-pagination-footer="false"
    :show-know-more="false"
    :button-label="t('CAPTAIN.ASSISTANTS.FORM.UPDATE')"
    button-icon=""
    :button-disabled="isUpdating"
    :button-loading="isUpdating"
    @click="handleHeaderClick"
  >
    <template #body>
      <div class="flex flex-col gap-6 pb-8">
        <SettingsHeader
          :heading="t('CAPTAIN.ASSISTANTS.SETTINGS.COMPANY.TITLE')"
          :description="t('CAPTAIN.ASSISTANTS.SETTINGS.COMPANY.DESCRIPTION')"
        />
        <AssistantCompanyForm
          ref="companyFormRef"
          :assistant="assistant"
          @submit="handleSubmit"
        />
      </div>
    </template>
  </PageLayout>
</template>
